import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id 6A261917-D952-4EFD-B8A4-9A91BCF67DE1
 * name alpha-v
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-v.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphaVIcon = createSvgIcon(<><path d="M9,7L11,17H13L15,7H13L12,12L11,7H9Z" /></>, 'AlphaVIcon');
export default AlphaVIcon